import { createSlice } from "@reduxjs/toolkit";

const revenueSlice = createSlice({
  name: "revenue",
  initialState: {
    ruleCount: 0,
    hasRules: true,
  },
  reducers: {
    setRuleCount: (state, action) => {
      state.ruleCount = action.payload;
    },
    setHasRules: (state, action) => {
      state.hasRules = action.payload;
    },
  },
});

export const { setRuleCount, setHasRules } = revenueSlice.actions;
export default revenueSlice.reducer;